import BuildYourRoof from '../BuildYourRoof/BuildYourRoof';
import { withRailsContext } from '../RailsContext';

export default withRailsContext(BuildYourRoof);
